import en from './en.json';
import es from './es.json';
import fil from './fil.json';
import zhHans from './zh-Hans.json';
import zhHant from './zh-Hant.json';

const i18nResources = {
    en: {
        translation: en,
    },
    es: {
        translation: es,
    },
    fil: {
        translation: fil,
    },
    'zh-Hans': {
        translation: zhHans,
    },
    'zh-Hant': {
        translation: zhHant,
    },
};

export default i18nResources;
